<rd-popup-default-template
  [title]="'offer.locations_modal.title' | translate"
  [dialogContent]="dialogContent">
  <ng-template #dialogContent>
    <div class="container">
      <div class="content">
        <div class="location" *ngFor="let location of getLocations()">
          <div>{{ location.address }}</div>
          <div *ngIf="location.phone" class="phone-number-wrapper">
            <a
              [href]="'tel:' + location.phone"
              class="phone-number mt-1 ml-1 flex items-center gap-2.5">
              <rd-shared-icon
                class="phone-icon"
                [iconSymbol]="'icon-phone'"></rd-shared-icon>

              {{ location.phone }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</rd-popup-default-template>
